import React from "react";
import PropTypes from "prop-types";
import { Paper, withStyles } from "@material-ui/core";
import { useIntl } from "react-intl";

import { Tipografia } from "../../../../_common";

const styles = {
  textoEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: 8 },
  texto: { whiteSpace: "pre-line", paddingBottom: 8, wordBreak: "break-word", fontSize: 12 },
  textoResponsavel: { whiteSpace: "pre-line", paddingBottom: 5 },
  mensagem: { whiteSpace: "pre-line", paddingBottom: 5, wordBreak: "break-word", fontSize: 14 },
};

function TimeLineItemPipedrive({ evento, isTimelineAtividades, classes }) {
  const intl = useIntl();
  return (
    <Paper className={classes.textoEvento} zDepth={1} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.textoResponsavel}>
        {evento.responsavel}
      </Tipografia>
      <Tipografia className={classes.mensagem}>
        {intl.formatMessage({ defaultMessage: "Lead enviado com sucesso ao Pipedrive" })}
      </Tipografia>
      {evento.dealId && <span className={classes.texto}>DealId/Oportunidade: {evento.dealId}</span>}
      {evento.personId && <span className={classes.texto}>PersonId/Contato: {evento.personId}</span>}
      {evento.activityId && <span className={classes.texto}>ActivityId/Compromisso: {evento.activityId}</span>}
      {evento.companyId && <span className={classes.texto}>CompanyId/Organização: {evento.companyId}</span>}
    </Paper>
  );
}

TimeLineItemPipedrive.propTypes = {
  evento: PropTypes.object,
  classes: PropTypes.object,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimeLineItemPipedrive);
